module.exports = "#version 300 es\nprecision highp float;\n\nin vec2 fs_UV;\nout vec4 out_Col;\n\nuniform sampler2D u_frame0;\n\nvoid main() {\n\n\tvec2 reUV = vec2(fs_UV.x, 1.0 - fs_UV.y);\n\tout_Col = texture(u_frame0, reUV);\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/SSRMip-frag.glsl
// module id = 33
// module chunks = 0